import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { doc, setDoc, serverTimestamp, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import "../style/AuthPage.css";

export default function AuthPage() {
  const [isLogin, setIsLogin] = useState(true);
  const [showPopup, setShowPopup] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [phone, setPhone] = useState("");

  const [passwordError, setPasswordError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  // 👁️ Show / Hide Password
  const [showPassword, setShowPassword] = useState(false);

  // 🔐 Password strength
  const [passwordStrength, setPasswordStrength] = useState("");

  // 👤 Logged-in name
  const [userName, setUserName] = useState("");

  const navigate = useNavigate();

  const phoneRegex = /^[0-9]{10}$/;
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#]).{8,}$/;

  // 🔐 Password strength logic
  const checkPasswordStrength = (value) => {
    if (value.length < 6) return "Weak";
    if (passwordRegex.test(value)) return "Strong";
    return "Medium";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setPasswordError("");
    setPhoneError("");

    if (!isLogin && !passwordRegex.test(password)) {
      setPasswordError(
        "Password must be at least 8 characters and include uppercase, lowercase, number, and special character."
      );
      return;
    }

    if (!isLogin && !phoneRegex.test(phone)) {
      setPhoneError("Phone number must be exactly 10 digits.");
      return;
    }

    try {
      let user;

      if (isLogin) {
        const res = await signInWithEmailAndPassword(auth, email, password);
        user = res.user;

        // 🔥 Fetch user name from Firestore
        const docSnap = await getDoc(doc(db, "users", user.uid));
        if (docSnap.exists()) {
          setUserName(docSnap.data().fullName);
        }
      } else {
        const res = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );
        user = res.user;

        await setDoc(doc(db, "users", user.uid), {
          fullName,
          phone,
          email,
          role: "user",
          createdAt: serverTimestamp(),
        });

        setUserName(fullName);
      }

      setShowPopup(true);
      setTimeout(() => navigate("/"), 2000);
    } catch (error) {
      setPasswordError(error.message);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>{isLogin ? "Login" : "Register"}</h1>

        <form className="auth-form" onSubmit={handleSubmit}>
          {!isLogin && (
            <input
              type="text"
              placeholder="Full Name"
              required
              onChange={(e) => setFullName(e.target.value)}
            />
          )}

          {!isLogin && (
            <>
              <input
                type="tel"
                placeholder="Phone Number"
                maxLength="10"
                value={phone}
                className={phoneError ? "input-error" : ""}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  setPhone(value);
                  setPhoneError("");
                }}
              />
              {phoneError && <p className="error-text">{phoneError}</p>}
            </>
          )}

          <input
            type="email"
            placeholder="Email Address"
            required
            onChange={(e) => setEmail(e.target.value)}
          />

          {/* 🔐 Password with Show / Hide */}
          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className={passwordError ? "input-error" : ""}
              required
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordStrength(checkPasswordStrength(e.target.value));
                setPasswordError("");
              }}
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>

          {/* 🔐 Password strength */}
          {!isLogin && password && (
            <p className={`strength ${passwordStrength.toLowerCase()}`}>
              Password strength: {passwordStrength}
            </p>
          )}

          {passwordError && <p className="error-text">{passwordError}</p>}

          <button type="submit" className="auth-btn">
            {userName ? `Welcome, ${userName}` : isLogin ? "Login" : "Register"}
          </button>
        </form>

        <p className="toggle-text">
          {isLogin ? "Don’t have an account?" : "Already have an account?"}
          <span onClick={() => setIsLogin(!isLogin)}>
            {isLogin ? " Register here" : " Login here"}
          </span>
        </p>
      </div>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3>
              {isLogin ? "Login Successful" : "Registration Successful"}
            </h3>
            <p>Redirecting to homepage...</p>
          </div>
        </div>
      )}
    </div>
  );
}
